import { Button, Tooltip, message, Modal } from "antd";
import React, { useContext } from "react";
import PriceWidget from "./PriceWidget";
import Counter from "./Counter";
import { AppContext } from "../../store";
import defaultProductPic from "../../images/default-brand.jpg";
import { getAuthToken, handleLogin } from "../../utils/common";
import { getSelectedSTObj } from "../../utils/addressUtils";
import axios from "axios";
import { cartAddUrl } from "../../utils/constant";
import { addToCartErrorHandle, gotoPdp } from "Utils/activityHelper";
import { logOperation } from "Utils/operationLogUtils";
import { addToCartDataPush, cartTrackingDataPush } from "Utils/analyticsUtils";
export interface ProductCardProps {
  product: {
    sku: number | string;
    productSize?: string;
    productName: string;
    pdpViewable?: boolean;
    productPic?: string;
    description?: string;
    listPrice?: number | string;
    promoPrice?: number | string;
    priceStatus?: string;
    shoppingQty?: number;
    finalPrice?: number | string;
    level1Qty?: number;
    level1Price?: string;
    level2Qty?: number;
    level2Price?: number | string;
    priceType?: string;
  };
  cartData?: Object;
  previewData?: Object;
  isOrderPreviewFlag?: true,
  loginState?: Object;
  tab?: string;
  activityId?: number | string;
  previewFlag?: boolean;
  onAddToCart?: () => void;
}
export type CounterRef = {
  addToCart: () => void; // Add this line
  updateShoppingQty: (newQty: number) => void;
};

const ProductCard: React.FC<ProductCardProps> = (props: any) => {
  const [showGoModal, setShowGoModal] = React.useState(false);
  const { checkedCartItems, setCheckedCartItems, setCartCount } =
    useContext(AppContext);
  const {
    product,
    loginState,
    tab,
    activityId,
    previewFlag,
    onAddToCart,
  } = props;
  const [shoppingQty, setShoppingQty] = React.useState<number>(
    product.shoppingQty || 1
  );
  const [processing, setProcessing] = React.useState<boolean>(false);
  const handleShoppingQty = (newQty: number) => {
    setShoppingQty(newQty);
  };

  const doGoPdp = () => {
    const holder = tab === "activity" ? "Activity_Detail" : "Exchange_Detail";
    gotoPdp(product, loginState, holder);
  };

  return (
    <div className="productCardWrapper">
      <div className="productCard">
        <div className="top">
          <div className="line line1">
            <span>{product.sku}</span>
            <span
              dangerouslySetInnerHTML={{ __html: product.productSize }}
            ></span>
          </div>
          {product.productName ? <Tooltip
            title={
              <div
                dangerouslySetInnerHTML={{ __html: product.productName }}
              ></div>
            }
            trigger={"hover"}
          >
            <div
              className={
                product.pdpViewable ? "line line2 linkable" : "line line2"
              }
              onClick={() => {
                console.log("product card clicked");
                if (!product.pdpViewable) {
                  // 可选：message.info("该产品暂无详情页");
                  return;
                }
                setShowGoModal(true);
              }}
              dangerouslySetInnerHTML={{ __html: product.productName }}
            ></div>
          </Tooltip> : <div
            className={
              product.pdpViewable ? "line line2 linkable" : "line line2"
            }
            onClick={() => {
              console.log("product card clicked");
              if (!product.pdpViewable) {
                // 可选：message.info("该产品暂无详情页");
                return;
              }
              setShowGoModal(true);
            }}
          > </div>}
          {product.description && (
            <Tooltip title={product.description} trigger={"hover"}>
              <div
                className="line line3"
                dangerouslySetInnerHTML={{ __html: product.description }}
              ></div>
            </Tooltip>
          )}
          <div className="line line4">
            <div className="imgWrapper">
              <img
                alt={product.productName}
                src={product.productPic || defaultProductPic}
                onClick={() => {
                  if (!product.pdpViewable) {
                    // 可选：message.info("该产品暂无详情页");
                    return;
                  }
                  setShowGoModal(true);
                }}
              ></img>
            </div>
            <PriceWidget product={product} loginState={loginState} />
          </div>
        </div>
        <div className="line line5">
          <Counter
            value={shoppingQty}
            onChange={handleShoppingQty}
            product={product}
            login={!!(loginState?.status === "login")}
          ></Counter>
          <div>
            {loginState?.status === "login" ? (
              <Button
                className="primaryBtn addCartBtn"
                disabled={previewFlag || !product.available}
                onClick={(e) => {
                  console.log("add to cart");
                  if (!shoppingQty) return;
                  if (processing) return;
                  setProcessing(true);
                  e.stopPropagation();
                  const selectedST = getSelectedSTObj(loginState);
                  axios(cartAddUrl, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: getAuthToken(),
                    },
                    data: {
                      activityId: activityId,
                      type: tab,
                      category: product.category,
                      sku: product.sku,
                      quantity: shoppingQty,
                      customerStNumber: selectedST?.accountNumber,
                    },
                  })
                    .then((resp) => {
                      console.log("add to cart", resp);
                      const respData = resp.data;
                      if (respData?.status === "success") {
                        // message.success("已加入购物车");
                        const ids: number[] = respData?.data?.cartIds;
                        const count = respData?.data?.cartCount || 0;
                        ids && checkedCartItems.add(ids[0]);
                        setCheckedCartItems(new Set(checkedCartItems));
                        setCartCount(count);
                        onAddToCart && onAddToCart();
                        // cartTrackingDataPush({
                        //   actionType: "add",
                        //   dispatchObj: {
                        //     method: "add products",
                        //     placement: "marketing detail",
                        //     products: [{
                        //       name: product.productName,
                        //       catalogId: product.sku,
                        //       price: product.finalPrice ? (Number(product.finalPrice) * shoppingQty).toFixed(2) : '0',
                        //       quantity: shoppingQty
                        //     }]
                        //   }
                        // })
                        const cartObj = {
                          cartId: activityId
                        };
                        const fprice = product.promoPrice || product.finalPrice || '0';
                        addToCartDataPush({
                          cartObj,
                          placement: "marketing_detail",
                          method: "product_card",
                          products: [{
                            name: product?.productName,
                            catalogId: product.sku,
                            quantity: 1,
                            price: fprice ? (fprice * 1).toFixed(2) : "0",
                          }]
                        })
                        setProcessing(false);
                        return;
                      }
                      addToCartErrorHandle(respData, message, 'common', 'pc');
                      setProcessing(false);
                    })
                    .catch((err) => {
                      console.log("add to cart error", err);
                      setProcessing(false);
                      message.error(
                        "加入购物车失败, 可能是该产品不支持在线下单，如果问题持续，请联系客服"
                      );
                    });
                  logOperation({
                    opUser: loginState?.user?.user?.userId,
                    opTarget: "Add_To_Cart",
                    opTargetId: product.sku,
                    opContent:
                      tab === "activity"
                        ? "Activity_Detail"
                        : "Exchange_Detail",
                  });
                }}
              >
                {product.available ? "加购" : "已售罄"}
              </Button>
            ) : (
              <Button className="primaryBtn addCartBtn" onClick={handleLogin}>
                加购
              </Button>
            )}
          </div>
        </div>
      </div>
      <Modal
        title="提示"
        open={showGoModal}
        getContainer={document.body}
        onCancel={() => setShowGoModal(false)}
        style={{top: '35%'}}
        className="show-go-to-detail-info-modal"
        footer={[
          <Button
            key="ok"
            onClick={() => {
              setShowGoModal(false);
              doGoPdp();          // 确认后再走原逻辑
            }}
          >
            继续前往
          </Button>,
          <Button key="cancel" type="primary"  onClick={() => setShowGoModal(false)}>
            留在本页
          </Button>,
        ]}
      >
      <p>该促销仅限当前页面加购才可享受，浏览产品详情后需返回本页面参与。</p>
    </Modal>
    </div>
  );
};

export default ProductCard;
